import React from 'react';
import { Card, Avatar, Tag } from 'antd';
import {
    MailOutlined,
    PhoneOutlined,
    BankOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';
import { getInitials } from '../../../../../utils/helper';

const EnhancedLowActivityUsersCardView = ({
    record,
    onStatusChange,
    onCardClick
}) => {
    const initials = getInitials(record.name || record.email);

    return (
        <Card
            hoverable
            className="h-full relative transition-all duration-200"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-3 sm:space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-2 sm:space-x-3 overflow-hidden">
                        <Avatar
                            size={40}
                            className="flex-shrink-0 font-semibold text-base sm:text-lg !bg-primary sm:w-12 sm:h-12"
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-sm sm:text-base mb-1 truncate capitalize" title={record.name}>
                                {record.name || "N/A"}
                            </h3>
                            {record.email && (
                                <div className="flex items-center text-gray-500 text-xs sm:text-sm mb-0">
                                    <MailOutlined className="mr-1.5 flex-shrink-0" />
                                    <span className="truncate" title={record.email}>
                                        {record.email}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Details Section */}
                <div className="space-y-2 sm:space-y-3 pt-1.5 sm:pt-2">
                    {/* Phone */}
                    <div className="flex items-center justify-between">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium flex items-center">
                            <PhoneOutlined className="mr-2" />
                            Phone:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700 truncate max-w-[60%]" title={record.phone}>
                            {record.phone || "N/A"}
                        </span>
                    </div>

                    {/* Company */}
                    <div className="flex items-center justify-between">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium flex items-center">
                            <BankOutlined className="mr-2" />
                            Company:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700 truncate max-w-[60%]" title={record.company}>
                            {record.company || "N/A"}
                        </span>
                    </div>

                    {/* Verified Status */}
                    <div className="flex items-center justify-between border-t border-gray-200 pt-2 sm:pt-3 mt-2 sm:mt-3">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium flex items-center">
                            {record.verified === 'y' ? <CheckCircleOutlined className="mr-2" /> : <CloseCircleOutlined className="mr-2" />}
                            Status:
                        </span>
                        <Tag
                            color={record.verified === 'y' ? 'success' : 'error'}
                            className="text-[10px] sm:text-xs cursor-pointer select-none"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (onStatusChange) {
                                    onStatusChange(record._id, record.verified);
                                }
                            }}
                        >
                            {record.verified === 'y' ? "Verified" : "Not Verified"}
                        </Tag>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedLowActivityUsersCardView;
